import { Table, TableCell, TableColumn } from "@mcleod/components";
import { ActionAddToContainer } from "./ActionAddToContainer";
import { ActionAddToContainerResult } from "./ActionAddToContainerResult";

export class ActionAddTableColumn implements ActionAddToContainer {
    table: Table;
    designer: any;
    tableColumn: TableColumn;

    constructor(table: Table) {
        this.table = table;
    }

    async execute(): Promise<ActionAddToContainerResult> {
        this.tableColumn = this.table._createNewColumnForDesigner();
        this.table.addColumn(this.tableColumn);
        const headerCell = this.tableColumn.headingCell;

        const rowCell = new TableCell({ table: this.table, row: this.table.rows[0], col: this.tableColumn });
        this.table.rows[0].addCell(rowCell, this.tableColumn.index);
        return { success: true, componentsAdded: [headerCell, rowCell] };
    }

    undo() {
        this.table.removeColumn(this.tableColumn.index);
    }

    toString() {
        return "Add Table Column";
    }
}
